import classes from '@/components/Shares/Table.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Box, Flex, Group, Image, NumberFormatter, Table, Text } from '@mantine/core';
import { tableRows } from './tableRows';
export const BetsTable: React.FC = () => {
  const {
    setOpenModal
  } = useModalAction();
  const {
    i18n
  } = useLingui();
  const rows = tableRows.map(row => <Table.Tr key={row.name} onClick={() => setOpenModal(MODAL.INFO, row.time)}>
      <Table.Td miw={{
      base: 230,
      md: 280,
      lg: 300,
      xl: 350
    }}>
        <Group wrap="nowrap">
          <Image src={row.game} alt="game" />
          <Text fz={{
          base: 'xs',
          md: 13
        }}>{row.gameName}</Text>
        </Group>
      </Table.Td>
      <Table.Td miw={150} visibleFrom="sm">
        <Group wrap="nowrap">
          <Image src={row.user} alt="user" />
          <Text fz={{
          base: 'xs',
          md: 13
        }}>{row.name}</Text>
        </Group>
      </Table.Td>
      <Table.Td miw={80} visibleFrom="sm">
        <Text fz={{
        base: 'xs',
        md: 13
      }}>{row.time}</Text>
      </Table.Td>
      <Table.Td miw={100} visibleFrom="sm">
        <Text fz={{
        base: 'xs',
        md: 13
      }}>
          <NumberFormatter prefix="$" value={row.wager} />
        </Text>
      </Table.Td>
      <Table.Td miw={120} visibleFrom="sm">
        <Text fz={{
        base: 'xs',
        md: 13
      }}>{row.multi}</Text>
      </Table.Td>
      <Table.Td miw={{
      base: 60,
      sm: 150
    }}>
        <Flex justify={{
        base: 'end',
        sm: 'start'
      }}>
          <Box w={{
          base: 55,
          sm: 70,
          md: '100%'
        }}>
            <Text c="prime.9" fz={{
            base: 'xs',
            md: 13
          }} ta={{
            base: 'right',
            sm: 'left'
          }} truncate="end">
              <NumberFormatter prefix="$" decimalSeparator="." thousandSeparator="," decimalScale={2} fixedDecimalScale value={row.amount} />
            </Text>
          </Box>
        </Flex>
      </Table.Td>
    </Table.Tr>);
  const ths = <Table.Tr>
      <Table.Th fz={{
      base: 10,
      md: 12
    }} w={{
      base: 230,
      md: 300
    }}>
        {i18n._('GAME')}
      </Table.Th>
      <Table.Th visibleFrom="sm" fz={{
      base: 10,
      md: 12
    }}>
        {i18n._('PLAYER/CLAN')}
      </Table.Th>
      <Table.Th visibleFrom="sm" w={150} fz={{
      base: 10,
      md: 12
    }}>
        {i18n._('TIME')}
      </Table.Th>
      <Table.Th visibleFrom="sm" fz={{
      base: 10,
      md: 12
    }}>
        {i18n._('WAGER')}
      </Table.Th>
      <Table.Th visibleFrom="sm" fz={{
      base: 10,
      md: 12
    }}>
        {i18n._('MULTIPLIER')}
      </Table.Th>
      <Table.Th fz={{
      base: 10,
      md: 12
    }} ta={{
      base: 'right',
      sm: 'left'
    }}>
        {i18n._('WIN AMOUNT')}
      </Table.Th>
    </Table.Tr>;
  return <Table.ScrollContainer minWidth={300}>
      <Table striped classNames={classes}>
        <Table.Thead>{ths}</Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Table.ScrollContainer>;
};